import { FC, useState } from "react";
import { Box, makeStyles } from "@material-ui/core";

import { LogInRequiredModal } from "components";
import {
  formatMarketplaceMedian,
  formatMarketplaceMedianAmountSource,
  formatNumber,
} from "lib/format";

const useStyles = makeStyles(theme => ({
  subtitle: {
    fontSize: "11.9px",
    display: "block",
    color: theme.custom.palette.softGray.main,
  },
  usersOnlyLink: {
    ...theme.typography.caption,
    display: "block",
    color: theme.custom.palette.blue.main,
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

interface MarketplaceMedianProps {
  marketplaceMedianSource: string | null;
  offer: string | null;
  multiplier: string | null;
}

const MarketplaceMedian: FC<MarketplaceMedianProps> = ({
  marketplaceMedianSource,
  offer,
  multiplier,
}) => {
  const classes = useStyles();
  const [
    isMarketplaceMedianModalOpen,
    setIsMarketplaceMedianModalOpen,
  ] = useState(false);

  return (
    <>
      {isMarketplaceMedianModalOpen && (
        <LogInRequiredModal
          open
          onClose={() => setIsMarketplaceMedianModalOpen(false)}
        />
      )}
      <Box onClick={e => !multiplier && e.stopPropagation()}>
        <Box>
          {formatMarketplaceMedian(offer)}
          {offer === null ? (
            <span className={classes.subtitle}>—</span>
          ) : !!multiplier ? (
            <span className={classes.subtitle}>
              {`${formatNumber(
                Number(multiplier),
              )} x ${formatMarketplaceMedianAmountSource(
                marketplaceMedianSource,
              )}`}
            </span>
          ) : (
            <span
              className={classes.usersOnlyLink}
              onClick={e => {
                e.stopPropagation();
                setIsMarketplaceMedianModalOpen(true);
              }}
            >
              Users Only
            </span>
          )}
        </Box>
      </Box>
    </>
  );
};

export default MarketplaceMedian;
